module.exports = __webpack_public_path__ + "img/image53.fec29e4d.png";